var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('i',{class:['fa', _vm.icon, 'space-right']}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phoneNumber))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1da75f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/PhoneNumber.vue
// module id = 261
// module chunks = 0 1 5